import { render } from "./vBox_news.vue?vue&type=template&id=0cbadedb&scoped=true"
import script from "./vBox_news.vue?vue&type=script&lang=js"
export * from "./vBox_news.vue?vue&type=script&lang=js"

import "./vBox_news.vue?vue&type=style&index=0&id=0cbadedb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cbadedb"]])

export default __exports__